import React, { createContext, useCallback, useContext, useMemo } from "react";

interface NavCallbacks {
  goNext: (() => void) | null;
  goPrev: (() => void) | null;
}

interface BackgroundNavContextValue extends NavCallbacks {
  setNav: (nav: NavCallbacks) => void;
}

const BackgroundNavContext = createContext<BackgroundNavContextValue>({
  goNext: null,
  goPrev: null,
  setNav: () => {},
});

export const useBackgroundNav = () => useContext(BackgroundNavContext);

export const BackgroundNavProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [nav, setNavState] = React.useState<NavCallbacks>({
    goNext: null,
    goPrev: null,
  });

  const setNav = useCallback((next: NavCallbacks) => {
    setNavState(next);
  }, []);

  const value = useMemo<BackgroundNavContextValue>(
    () => ({ ...nav, setNav }),
    [nav, setNav],
  );

  return (
    <BackgroundNavContext.Provider value={value}>
      {children}
    </BackgroundNavContext.Provider>
  );
};
